// Double Elimination Bracket Templates
// Pre-defined bracket structures for different player counts
// This ensures correct BYE placement and tournament structure

const DOUBLE_ELIMINATION_TEMPLATES = {
  // 3 players (4 slots, 1 BYE)
  3: {
    slots: 4,
    byes: 1,
    byePositions: [0]
  },

  // 4 players (4 slots, no BYEs)
  4: {
    slots: 4,
    byes: 0,
    byePositions: []
  },

  // 5 players (8 slots, 3 BYEs)
  5: {
    slots: 8,
    byes: 3,
    byePositions: [0, 4, 7]
  },

  // 6 players (8 slots, 2 BYEs)
  6: {
    slots: 8,
    byes: 2,
    byePositions: [0, 7]
  },

  // 7 players (8 slots, 1 BYE)
  7: {
    slots: 8,
    byes: 1,
    byePositions: [0]
  },

  // 8 players (8 slots, no BYEs)
  8: {
    slots: 8,
    byes: 0,
    byePositions: []
  },

  // 9 players (16 slots, 7 BYEs)
  9: {
    slots: 16,
    byes: 7,
    byePositions: [0, 4, 6, 8, 10, 12, 14]
  },

  // 10 players (16 slots, 6 BYEs)
  10: {
    slots: 16,
    byes: 6,
    byePositions: [0, 4, 6, 8, 12, 14]
  },

  // 11 players (16 slots, 5 BYEs)
  11: {
    slots: 16,
    byes: 5,
    byePositions: [0, 4, 6, 8, 12]
  },

  // 12 players (16 slots, 4 BYEs)
  12: {
    slots: 16,
    byes: 4,
    byePositions: [0, 4, 8, 12]
  },

  // 13 players (16 slots, 3 BYEs)
  13: {
    slots: 16,
    byes: 3,
    byePositions: [0, 8, 12]
  },

  // 14 players (16 slots, 2 BYEs)
  14: {
    slots: 16,
    byes: 2,
    byePositions: [0, 8]
  },

  // 15 players (16 slots, 1 BYE)
  15: {
    slots: 16,
    byes: 1,
    byePositions: [0]
  },

  // 16 players (16 slots, no BYEs)
  16: {
    slots: 16,
    byes: 0,
    byePositions: []
  },

  // 17 players (32 slots, 15 BYEs)
  17: {
    slots: 32,
    byes: 15,
    byePositions: [0, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30]
  },

  // 18 players (32 slots, 14 BYEs)
  18: {
    slots: 32,
    byes: 14,
    byePositions: [0, 4, 6, 8, 10, 12, 14, 16, 20, 22, 24, 26, 28, 30]
  },

  // 19 players (32 slots, 13 BYEs)
  19: {
    slots: 32,
    byes: 13,
    byePositions: [0, 4, 6, 8, 10, 12, 14, 16, 20, 22, 24, 28, 30]
  },

  // 20 players (32 slots, 12 BYEs)
  20: {
    slots: 32,
    byes: 12,
    byePositions: [0, 4, 6, 8, 12, 14, 16, 20, 22, 24, 28, 30]
  },

  // 21 players (32 slots, 11 BYEs)
  21: {
    slots: 32,
    byes: 11,
    byePositions: [0, 4, 6, 8, 12, 16, 20, 22, 24, 28, 30]
  },

  // 22 players (32 slots, 10 BYEs)
  22: {
    slots: 32,
    byes: 10,
    byePositions: [0, 4, 6, 8, 12, 16, 20, 22, 24, 28]
  },

  // 23 players (32 slots, 9 BYEs)
  23: {
    slots: 32,
    byes: 9,
    byePositions: [0, 4, 8, 12, 16, 20, 22, 24, 28]
  },

  // 24 players (32 slots, 8 BYEs)
  24: {
    slots: 32,
    byes: 8,
    byePositions: [0, 4, 8, 12, 16, 20, 24, 28]
  },

  // 25 players (32 slots, 7 BYEs)
  25: {
    slots: 32,
    byes: 7,
    byePositions: [0, 8, 12, 16, 20, 24, 28]
  },

  // 26 players (32 slots, 6 BYEs)
  26: {
    slots: 32,
    byes: 6,
    byePositions: [0, 8, 12, 16, 20, 24]
  },

  // 27 players (32 slots, 5 BYEs)
  27: {
    slots: 32,
    byes: 5,
    byePositions: [0, 8, 12, 16, 24]
  },

  // 28 players (32 slots, 4 BYEs)
  28: {
    slots: 32,
    byes: 4,
    byePositions: [0, 8, 16, 24]
  },

  // 29 players (32 slots, 3 BYEs)
  29: {
    slots: 32,
    byes: 3,
    byePositions: [0, 16, 24]
  },

  // 30 players (32 slots, 2 BYEs)
  30: {
    slots: 32,
    byes: 2,
    byePositions: [0, 16]
  },

  // 31 players (32 slots, 1 BYE)
  31: {
    slots: 32,
    byes: 1,
    byePositions: [0]
  },

  // 32 players (32 slots, no BYEs)
  32: {
    slots: 32,
    byes: 0,
    byePositions: []
  },

  // ===== 64-SLOT TEMPLATES (33-64 players) =====
  // For 64 slots: First round has 32 matches (M1-M32)
  // BYE placement follows standard tournament seeding (top seeds get byes)
  // Losers Round 1 is dynamically generated from Winners Round 1

  // 33 players (64 slots, 31 BYEs)
  33: {
    slots: 64,
    byes: 31,
    byePositions: [0, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 32, 34, 36, 38, 40, 42, 44, 46, 48, 50, 52, 54, 56, 58, 60, 62]
  },

  // 34 players (64 slots, 30 BYEs)
  34: {
    slots: 64,
    byes: 30,
    byePositions: [0, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 32, 36, 38, 40, 42, 44, 46, 48, 50, 52, 54, 56, 58, 60, 62]
  },

  // 35 players (64 slots, 29 BYEs)
  35: {
    slots: 64,
    byes: 29,
    byePositions: [0, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 32, 36, 38, 40, 42, 44, 46, 48, 52, 54, 56, 58, 60, 62]
  },

  // 36 players (64 slots, 28 BYEs)
  36: {
    slots: 64,
    byes: 28,
    byePositions: [0, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 28, 30, 32, 36, 38, 40, 42, 44, 46, 48, 52, 54, 56, 58, 60, 62]
  },

  // 37 players (64 slots, 27 BYEs)
  37: {
    slots: 64,
    byes: 27,
    byePositions: [0, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 28, 32, 36, 38, 40, 42, 44, 46, 48, 52, 54, 56, 58, 60, 62]
  },

  // 38 players (64 slots, 26 BYEs)
  38: {
    slots: 64,
    byes: 26,
    byePositions: [0, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 28, 32, 36, 38, 40, 42, 44, 46, 48, 52, 54, 56, 58, 60]
  },

  // 39 players (64 slots, 25 BYEs)
  39: {
    slots: 64,
    byes: 25,
    byePositions: [0, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 28, 32, 36, 38, 40, 42, 44, 48, 52, 54, 56, 58, 60]
  },

  // 40 players (64 slots, 24 BYEs)
  40: {
    slots: 64,
    byes: 24,
    byePositions: [0, 4, 6, 8, 10, 12, 14, 16, 20, 22, 24, 28, 32, 36, 38, 40, 44, 48, 52, 54, 56, 58, 60, 62]
  },

  // 41 players (64 slots, 23 BYEs)
  41: {
    slots: 64,
    byes: 23,
    byePositions: [0, 4, 6, 8, 10, 12, 14, 16, 20, 22, 24, 28, 32, 36, 38, 40, 44, 48, 52, 54, 56, 60, 62]
  },

  // 42 players (64 slots, 22 BYEs)
  42: {
    slots: 64,
    byes: 22,
    byePositions: [0, 4, 6, 8, 10, 12, 14, 16, 20, 22, 24, 28, 32, 36, 40, 44, 48, 52, 54, 56, 60, 62]
  },

  // 43 players (64 slots, 21 BYEs)
  43: {
    slots: 64,
    byes: 21,
    byePositions: [0, 4, 6, 8, 10, 12, 14, 16, 20, 22, 24, 28, 32, 36, 40, 44, 48, 52, 54, 60, 62]
  },

  // 44 players (64 slots, 20 BYEs)
  44: {
    slots: 64,
    byes: 20,
    byePositions: [0, 4, 6, 8, 10, 12, 14, 16, 20, 22, 24, 28, 32, 36, 40, 44, 48, 52, 56, 60]
  },

  // 45 players (64 slots, 19 BYEs)
  45: {
    slots: 64,
    byes: 19,
    byePositions: [0, 4, 6, 8, 10, 12, 14, 16, 20, 22, 24, 28, 32, 36, 40, 44, 48, 56, 60]
  },

  // 46 players (64 slots, 18 BYEs)
  46: {
    slots: 64,
    byes: 18,
    byePositions: [0, 4, 6, 8, 10, 12, 14, 16, 20, 24, 28, 32, 36, 40, 44, 48, 56, 60]
  },

  // 47 players (64 slots, 17 BYEs)
  47: {
    slots: 64,
    byes: 17,
    byePositions: [0, 4, 6, 8, 10, 12, 14, 16, 20, 24, 28, 32, 36, 40, 44, 48, 60]
  },

  // 48 players (64 slots, 16 BYEs)
  48: {
    slots: 64,
    byes: 16,
    byePositions: [0, 4, 8, 12, 16, 20, 24, 28, 32, 36, 40, 44, 48, 52, 56, 60]
  },

  // 49 players (64 slots, 15 BYEs)
  49: {
    slots: 64,
    byes: 15,
    byePositions: [0, 4, 8, 12, 16, 20, 24, 28, 32, 36, 40, 44, 48, 56, 60]
  },

  // 50 players (64 slots, 14 BYEs)
  50: {
    slots: 64,
    byes: 14,
    byePositions: [0, 4, 8, 12, 16, 20, 24, 28, 32, 36, 40, 44, 48, 56]
  },

  // 51 players (64 slots, 13 BYEs)
  51: {
    slots: 64,
    byes: 13,
    byePositions: [0, 4, 8, 12, 16, 20, 24, 28, 32, 36, 40, 48, 56]
  },

  // 52 players (64 slots, 12 BYEs)
  52: {
    slots: 64,
    byes: 12,
    byePositions: [0, 4, 8, 12, 16, 20, 24, 28, 32, 40, 48, 56]
  },

  // 53 players (64 slots, 11 BYEs)
  53: {
    slots: 64,
    byes: 11,
    byePositions: [0, 4, 8, 12, 16, 20, 24, 32, 40, 48, 56]
  },

  // 54 players (64 slots, 10 BYEs)
  54: {
    slots: 64,
    byes: 10,
    byePositions: [0, 4, 8, 12, 16, 24, 32, 40, 48, 56]
  },

  // 55 players (64 slots, 9 BYEs)
  55: {
    slots: 64,
    byes: 9,
    byePositions: [0, 4, 8, 16, 24, 32, 40, 48, 56]
  },

  // 56 players (64 slots, 8 BYEs)
  56: {
    slots: 64,
    byes: 8,
    byePositions: [0, 8, 16, 24, 32, 40, 48, 56]
  },

  // 57 players (64 slots, 7 BYEs)
  57: {
    slots: 64,
    byes: 7,
    byePositions: [0, 8, 16, 24, 32, 40, 48]
  },

  // 58 players (64 slots, 6 BYEs)
  58: {
    slots: 64,
    byes: 6,
    byePositions: [0, 8, 16, 24, 32, 48]
  },

  // 59 players (64 slots, 5 BYEs)
  59: {
    slots: 64,
    byes: 5,
    byePositions: [0, 8, 16, 32, 48]
  },

  // 60 players (64 slots, 4 BYEs)
  60: {
    slots: 64,
    byes: 4,
    byePositions: [0, 16, 32, 48]
  },

  // 61 players (64 slots, 3 BYEs)
  61: {
    slots: 64,
    byes: 3,
    byePositions: [0, 32, 48]
  },

  // 62 players (64 slots, 2 BYEs)
  62: {
    slots: 64,
    byes: 2,
    byePositions: [0, 32]
  },

  // 63 players (64 slots, 1 BYE)
  63: {
    slots: 64,
    byes: 1,
    byePositions: [0]
  },

  // 64 players (64 slots, no BYEs)
  64: {
    slots: 64,
    byes: 0,
    byePositions: []
  }

};

// Function to get the correct bracket template for a given number of players
export function getBracketTemplate(playerCount) {
  return DOUBLE_ELIMINATION_TEMPLATES[playerCount] || null;
}

// Function to populate bracket template with actual players
export function populateTemplate(template, players) {
  if (!template) return null;

  const slots = Array(template.slots).fill(null);

  // Place BYEs in designated positions
  template.byePositions.forEach(pos => {
    slots[pos] = "BYE";
  });

  // Place players in remaining slots in order of entry
  let playerIndex = 0;
  for (let i = 0; i < slots.length && playerIndex < players.length; i++) {
    if (slots[i] === null) {
      slots[i] = players[playerIndex++];
    }
  }

  return slots;
}